import { useImagings } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { Box } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import useFormPersist from 'react-hook-form-persist'
import * as yup from 'yup'

type Props = {
  onClose: () => void
}

export const addImagingSchema = yup.object({
  category: yup.string().required('Category is required'),
  description: yup.string(),
  price: yup.string().required('Price is required'),
  study_type: yup.string().required('Name is required')
})

export const AddImaging = ({ onClose }: Props) => {
  const methods = useForm({ resolver: yupResolver(addImagingSchema) })
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { isSubmitting }
  } = methods
  const { createImaging } = useImagings()

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          ...data,
          default: false
        },
        type: 'imaging'
      }
    }
    try {
      await createImaging(payload)
      showToast('Imaging added successfully')
      handleClose()
    } catch (error) {
      getError(error)
    }
  }
  const { clear } = useFormPersist('addImaging', { setValue, storage: window.localStorage, watch })

  const handleClose = () => {
    onClose()
    reset()
    clear()
  }

  return (
    <FormProvider {...methods}>
      <Modal onClose={handleClose} reset={reset} title="Add Imaging">
        <form className="flex flex-col overflow-auto pb-0" onSubmit={handleSubmit(onSubmit)}>
          <div className="px-8 py-4 flex flex-col w-full max-w-[530px] overflow-auto">
            <div className="mx-auto flex w-full max-w-[399px] flex-col gap-4">
              <Box pad="0">
                <FormInputField label="Name" name="study_type" placeholder="" />
              </Box>
              <Box pad="0">
                <FormInputField label="Category" name="category" placeholder="" />
              </Box>
              <Box pad="0">
                <FormInputField label="Price" name="price" placeholder="" type="number" />
              </Box>
              <Box>
                <TextAreaField label="Description" name="description" />
              </Box>
            </div>
          </div>
          <FormButton isLoading={isSubmitting} onClose={handleClose} />
        </form>
      </Modal>
    </FormProvider>
  )
}
